import { CitiesResponse } from './city';
import { StudentSocietyResponse } from './student-society';
import { TagResponse, TagsResponse, TagType } from './tag';
import { FollowingResponse } from './following';
import { UniversityResponse } from './university';
import { CompanyResponse } from './company';
import { TouchpointType } from './touchpoint';
import { OpportunityResponse } from './opportunity';
import { CohostsResponse } from './cohost';

export enum NestedType {
  STUDENT_SOCIETY = 'StudentSociety',
  COMPANY = 'Company',
}

export interface DummyMatchAttributes {
  id: string;
  title: string;
  icon_url: string;
  nested_type: string;
  sanitized_description: string;
  minimum_salary: number;
  maximum_salary: number;
  start_date: string;
  end_date: string;
  posted_at: string;
  university: UniversityResponse | null;
  name: string;
  company_icon_url: string;
  is_verified: boolean;
}

export interface MatchAttributes {
  id: string;
  created_at: string;
  matchable_id: string;
  matchable_type: string;
  title: string;
  icon_url: string;
  nested_type:
    | TouchpointType.Job
    | TouchpointType.Event
    | TouchpointType.Internship
    | NestedType.STUDENT_SOCIETY
    | NestedType.COMPANY;
  time_text: string;
  skipped_at: string;
  saved_at: string;
  viewed_at: string;
  apply_url: string;
  is_verified: boolean;
  minimum_salary: number;
  start_date: string;
  end_date: string;
  is_applied: boolean;
  description: string;
  sanitized_description: string;
  maximum_salary: number;
  pay_currency: string;
  is_recent: boolean;
  cities: CitiesResponse;
  topics: TagsResponse<TagType.Topic>;
  following: FollowingResponse | null;
  creatable_for: CompanyResponse | StudentSocietyResponse;
  university: UniversityResponse;
  application_deadline: string;
  matchable_slug: string;
  posted_at: string;
  matchable_created_at: string;
  primary_topic: TagResponse<TagType.Topic>;
  applications_count: number;
  capacity: number;
  enforce_capacity: boolean;
  touchpoint: OpportunityResponse;
  is_waitlisted: boolean;
  kind: string;
  preferred: boolean;
  cohost_applications: CohostsResponse;
}

export interface Match {
  id: string;
  type: 'match';
  attributes: MatchAttributes;
}

export interface MatchResponse {
  data: Match[];
  meta: {
    total: number;
  };
}

export interface MatchesResponse {
  touchpoints: {
    competitions: MatchResponse;
    events: MatchResponse;
    internships: MatchResponse;
    jobs: MatchResponse;
  };
  student_societies: MatchResponse;
  companies: MatchResponse;
  meta: {
    unvisited_count: number;
    unvisited_companies_count: number;
    unvisited_student_societies_count: number;
    unvisited_jobs_count: number;
    unvisited_internships_count: number;
    unvisited_events_count: number;
    viewed_count: number;
    viewed_companies_count: number;
    viewed_student_societies_count: number;
    viewed_jobs_count: number;
    viewed_internships_count: number;
    viewed_events_count: number;
    viewed_competitions_count: number;
    total_count: number;
    candidate_matches_state: {
      event_state_empty: boolean;
      internship_state_empty: boolean;
      job_state_empty: boolean;
    };
  };
}

export interface MatchUpdateResponse {
  data: Match;
}
